export default {
  allowAlignment: true,
  autoCenter: ['initialHeading', 'image'],
  allowImage: true,
  allowButton: false,
  allowVideo: true,
  allowSocial: false,
  allowHeading: true,
  allowSubheading: true,
  allowUploads: false,
  allowAttachments: false,
  allowCode: false
};